import { createTheme, colors } from "@material-ui/core";
const darktheme = createTheme({
  typography: {
    fontFamily: "Poppins, Roboto, Helvetica, Arial",
  },
  overrides: {
    MuiCssBaseline: {
      "@global": {
        "@font-face": ["Poppins", "Roboto", "Helvetica", "Arial"],
      },
    },
  },

  UpdateTheme: {
    button_color: "#1b1b1b",
    text_color: "#fff",
    heading_color: "#1b1b1b",
    theme_color: "#1b1b1b",
    link_color:  "#343434 !important",
    table_head_color: "#1b1b1b",
  },

  palette: {
    background: {
      dark: "transparent",
      default:  "#343434 !important",
      paper:  "#343434 !important",
    },
    header: {
      bg: "black",
      text: "white",
    },
    leftBar: {
      bg: "black",
      text: "white",
      active: "white",
    },
    primary: {
      main:  "#343434 !important",
    },
    secondary: {
      main:  "#343434 !important",
    },
    text: {
      primary: colors.common.white,
      secondary: colors.common.white,
    },
    button: {
      borderRadius: "20px",
      color: "white",
      background: "black !important",
      fontWeight: "500",
      fontSize: "16px",
      paddingRight: "20px",
      paddingLeft: "20px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "white",
      },
    },
    buttonSecondary: {
      borderRadius: "20px",
      color: "white",
      background: "black",
      fontWeight: "500",
      fontSize: "16px",
      paddingRight: "20px",
      paddingLeft: "20px",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "white",
      },
    },
    overrides: {
      MuiCssBaseline: {
        "@global": {
          "@font-face": ["Poppins", "Roboto", "Helvetica", "Arial"],
        },
      },
      MuiButton: {
        root: {
          color: "red", // Example button color
        },
      },
      // Add overrides for other Material-UI components here
    },
  },
});
export default darktheme;